import { inject, injectable } from 'inversify';
import ApiGlobalConfigService from 'src/common/apiGlobalConfig/ApiGlobalConfigService';
import {
  DeliverySchedule,
  DeliveryScheduleServiceInterface,
  GetDeliveryScheduleRequestParams,
} from 'src/features/checkout/domain/services/DeliveryScheduleService.interface';

@injectable()
class DeliveryScheduleService implements DeliveryScheduleServiceInterface {
  @inject(ApiGlobalConfigService)
  private globalConfigService!: ApiGlobalConfigService;

  async getDeliverySchedule(params: GetDeliveryScheduleRequestParams) {
    const response =
      await this.globalConfigService.getConfigBySlug<DeliverySchedule>({
        accessToken: params.accessToken,
        slug: 'delivery-dates-config',
      });

    return response.data.schema;
  }
}

export default DeliveryScheduleService;
